var supportedBrowsers = Object.freeze({
    edge: ">=13",
    chrome: ">=23",
    safari: ">=7",
    firefox: ">=24",
    desktop: {
        opera: ">=15",
    },
    mobile: {
        android: ">=4.4",
        blackberry: ">=10",
        samsung_internet: ">=4",
        opera: ">=46",
    },
});
export default supportedBrowsers;
//# sourceMappingURL=supportedBrowsers.js.map